<template>
<div class="surveillance-members-modal">
  <modal v-model="membersModal"
         :footer="false"
         size="lg"
         :title="`${surveillance.establishment.name} - SPIADI ${surveillance.year}`">
    <div v-if="membersModal"
         class="members-modal">
      <div v-for="c in categories"
           :key="`${c.type}-category`">
        <h3>
          <span :class="`label label-${c.type}`">{{ c.label }}</span>
        </h3>
        <sui-members-table :surveillance="surveillance" :module="c.type">
        </sui-members-table>
        <hr />
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import suiMembersTable from '@/sui/components/members/table'
import modules from '@/sui/data/modules'

export default {
  name: 'surveillance-members-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      membersModal: this.value
    }
  },

  watch: {
    membersModal: {
      handler () {
        this.$emit('input', this.membersModal)
        if (!this.membersModal) {
          this.result = null
          this.text = ''
        }
      },
      deep: true
    },

    value: function (value) {
      this.membersModal = value
    }
  },

  computed: {
    categories: function () {
      if (this.surveillance == null) {
        return []
      }

      const result = []
      for (let p in this.surveillance.modules) {
        result.push(
          {
            type: p,
            label: modules[this.surveillance.year][p].label
          }
        )
      }
      return result
    }
  },

  components: {
    'sui-members-table': suiMembersTable
  }
}
</script>

<style lang="less">

</style>
